import { PROPOSAL_BANNER_STYLES } from '@/modules/proposal/utils/constants';
import { debounce } from 'lodash';
import React, { useEffect, useState } from 'react';
import { HexColorPicker, HexColorInput } from 'react-colorful';
import ColorSelector from './ColorSelector';

type Props = {
  selected: string;
  onChange?: (color: string) => void;
};
export default function ColorSwatcher({ selected, onChange }: Props) {
  const [color, setColor] = useState(selected);

  useEffect(() => {
    setColor(selected);
  }, [selected]);

  const handleChange = (color: string) => {
    if (!onChange) {
      return null;
    }
    setColor(color);
    onChange(color);
  };

  return (
    <div className="color-swatcher">
      <HexColorPicker color={color} onChange={debounce(handleChange, 200)} className="color-gradientpicker mb-2" />
      <ColorSelector onChange={handleChange} colors={PROPOSAL_BANNER_STYLES.map(s => s.background)} selected={color} />
      <div className="input-hex">
        <label className="hex-label" htmlFor="hex-color-input">
          #
        </label>
        <HexColorInput color={color} id="hex-color-input" onChange={debounce(handleChange, 200)} className="color-hexinput" />
      </div>
    </div>
  );
}
